/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

import styles from './ElectroCheckboxGroup.module.scss';

/**
 * ElectroCheckboxGroup
 * Sends data as a comma separated string e.g. 'rental,used,new'
 *
 * @prop {Object} field
 * @return {React.Node}
 */
const ElectroCheckboxGroup: React.StatelessFunctionalComponent<*> = ({ field }: Object) => (
  <div className={styles['checkbox-group']}>
    <FormControl>
      <FormGroup>
        {field.options.map((item: Object) => (
          <FormControlLabel
            key={item.id}
            label={item.label}
            control={
              <Checkbox
                name={item.id}
                checked={field.value.indexOf(item.id) > -1}
                value={(field.value.indexOf(item.id) === -1).toString()}
                onChange={(evt: SyntheticInputEvent) => {
                  const id: string = evt.target.name;
                  const value: string = evt.target.value;
                  const arr: Array<string> = field.value ? field.value.split(',') : [];

                  if (value === 'true') {
                    arr.push(id);
                  } else {
                    arr.splice(arr.indexOf(id), 1);
                  }

                  field.set(arr.join());
                  field.validate();
                }}
              />
            }
          />
        ))}
      </FormGroup>
      {field.error && field.showError && (
        <FormHelperText error={true}>{field.error}</FormHelperText>
      )}
    </FormControl>
  </div>
);

export default observer(ElectroCheckboxGroup);
